module.exports = __webpack_public_path__ + "img/icon-for-photo.07a54bdd.png";